/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react'
import Swal from 'sweetalert2'
import { Modal, Button } from 'react-bootstrap'
import validationErrorMsg from '../helpers/ValidationErrorMsg'
import Spinner from 'react-bootstrap/Spinner'
import { getRequestOptions, postRequestOptions } from '../helpers/Fetchwrapper'
import Select from 'react-select'

interface ProductCategoryCreateProps {
	show: boolean;
	handleClose: any;
	id: number;
}

interface InitialState {
	idProductCategories: number | null;
	idProjects: number | null;
	categoryName: string;
	categoryCode: string;
	orderNo: string;
	idParentProductCategories: number | null;
}

const ProductCategoryCreate: React.FC<ProductCategoryCreateProps> = ({ show, handleClose, id }) => {

	const [projects, setProjects] = useState([]);
	const [project, setProject] = useState({ label: 'Select Project', value: '' });
	const [parentCategories, setParentCategories] = useState<any[]>([]);
	const [parentCategory, setParentCategory] = useState<{ label: string; value: string | number } | null>(null);

	const initialState: InitialState = {
		idProductCategories: null,
		idProjects: null,
		categoryName: '',
		categoryCode: '',
		orderNo: '',
		idParentProductCategories: null,
	};

	const getAllProjects = () => {
		fetch(
			process.env.REACT_APP_API_URL + 'projects',
			getRequestOptions()
		)
			.then((resp) => {
				return resp.json()
			})
			.then((resp) => {
				let projects = resp.data.map((item: any) => {
					item.label = item.project_name;
					item.value = item.id_projects;
					return item
				})
				setProjects(projects);
			})
			.catch((error) => {
				console.log(error, 'catch the hoop')
			})
	}

	const loadParentCategories = (projectId: number | string | null, selectedParentId: number | null = null, excludeId: number | null = null) => {
		if (!projectId) {
			setParentCategories([]);
			setParentCategory(null);
			return;
		}

		fetch(
			process.env.REACT_APP_API_URL + 'product-categories?idProjects=' + projectId,
			getRequestOptions()
		)
			.then((resp) => resp.json())
			.then((resp) => {
				const categories = (Array.isArray(resp) ? resp : (resp.data || [])).map((item: any) => ({
					...item,
					label: item.category_name,
					value: item.id_product_categories,
				})).filter((item: any) => excludeId == null || Number(item.value) !== Number(excludeId));

				setParentCategories(categories);

				if (selectedParentId) {
					const selected = categories.find((item: any) => Number(item.value) === Number(selectedParentId));
					setParentCategory(selected || null);
				} else {
					setParentCategory(null);
				}
			})
			.catch((error) => {
				console.log(error, 'catch the hoop')
			})
	}

	const [productCategory, setProductCategory] = useState(initialState);


	useEffect(() => {
		getAllProjects()
	}, [])

	useEffect(() => {
		if (id === 0) {
			setProductCategory({
				idProductCategories: null,
				categoryName: '',
				categoryCode: '',
				orderNo: '',
				idProjects: null,
				idParentProductCategories: null,
			});
			setProject({ label: 'Select Project', value: '' })
			setParentCategory(null);
			setParentCategories([]);
		} else {
			fetch(
				process.env.REACT_APP_API_URL + 'productCategories/edit/' + id,
				getRequestOptions()
			)
				.then((resp) => {
					return resp.json()
				})
				.then((resp) => {
					const parentId = resp.data.id_parent_product_categories ?? null;
					setProductCategory({
						idProductCategories: resp.data.id_product_categories,
						categoryName: resp.data.category_name,
						categoryCode: resp.data.category_code ?? '',
						orderNo: resp.data.order_no ?? '',
						idProjects: resp.data.id_projects,
						idParentProductCategories: parentId,
					});
					setProject({ label: resp.data.project_name, value: resp.data.id_projects })
					loadParentCategories(resp.data.id_projects, parentId, resp.data.id_product_categories);
				})
				.catch((error) => {
					console.log(error, 'catch the hoop')
				})
		}
	}, [id]);


	const [isSubmitDisable, setSubmitDisable] = useState(false);
	const [loading, setLoading] = useState(false);

	const handleChange = (e: any) => {
		setProductCategory({ ...productCategory, [e.target.name]: e.target.value });
	};

	const productCategorySave = async (event: any) => {
		event.preventDefault()
		setSubmitDisable(true);
		setLoading(true);
		const confirm = await Swal.fire({
			title: 'Are you sure?',
			text: "You want to " + (id === 0 ? "create" : "update") + " this Product Category?",
			icon: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#ec008c',
			cancelButtonText: 'Cancel',
			confirmButtonText: 'Yes, Submit it!',
		})
		if (confirm.value) {
			const payload = {
				...productCategory,
				orderNo: productCategory.orderNo === '' ? null : productCategory.orderNo,
				idParentProductCategories: productCategory.idParentProductCategories || null,
				categoryCode: productCategory.categoryCode || null,
			};
			const requestOptions = postRequestOptions(payload)
			try {
				let url = (id === 0) ? `${process.env.REACT_APP_API_URL}productCategories/store` : `${process.env.REACT_APP_API_URL}productCategories/update`
				let response = await fetch(
					url,
					requestOptions
				)
				let respData = await response.json()
				if (respData.success === true) {
					const successMsg = respData.successMessage
					Swal.fire({
						icon: 'success',
						title: 'Success',
						text: successMsg,
					})
					handleClose(respData.success)
				} else {
					const errorsMessage = validationErrorMsg(respData.errors).join('<br>')
					Swal.fire({
						icon: 'error',
						title: 'Error',
						html: errorsMessage,
					})
				}
				setSubmitDisable(false);
				setLoading(false);
			} catch (error) {
				console.log(error, 'catch the hoop')
				setSubmitDisable(false);
				setLoading(false);
			}
		} else {
			setSubmitDisable(false);
			setLoading(false);
		}
	}

	const handleProjectChange = (selectedProject: any) => {
		setProject(selectedProject);
		setProductCategory({
			...productCategory,
			idProjects: selectedProject.value,
			idParentProductCategories: null,
		});
		setParentCategory(null);
		loadParentCategories(selectedProject.value, null, id || null);
	}

	const handleParentCategoryChange = (selected: any) => {
		setParentCategory(selected);
		setProductCategory({
			...productCategory,
			idParentProductCategories: selected ? selected.value : null,
		});
	}


	return (
		<Modal show={show} onHide={() => handleClose(false)} size="lg">
			<form onSubmit={productCategorySave}>
				<Modal.Header closeButton>
					<Modal.Title>{id === 0 ? 'Create Product Category' : 'Edit Product Category'}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="form-group row">
						<label htmlFor="project" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Project <span className="required text-danger"></span></label>
						<div className="col-lg-5">
							<Select
								value={project}
								onChange={handleProjectChange}
								options={projects}
								menuPosition="fixed"
							/>
						</div>
					</div>
					<div className="form-group row">
						<label htmlFor="categoryName" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Name <span className="required text-danger"></span></label>
						<div className="col-lg-5">
							<input type="text" name="categoryName" id="categoryName" value={productCategory.categoryName} onChange={handleChange} className="form-control form-control-sm" />
						</div>
					</div>
					<div className="form-group row">
						<label htmlFor="categoryCode" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Category Code</label>
						<div className="col-lg-5">
							<input type="text" name="categoryCode" id="categoryCode" value={productCategory.categoryCode} onChange={handleChange} className="form-control form-control-sm" />
						</div>
					</div>
					<div className="form-group row">
						<label htmlFor="orderNo" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Order No</label>
						<div className="col-lg-5">
							<input type="number" name="orderNo" id="orderNo" value={productCategory.orderNo} onChange={handleChange} className="form-control form-control-sm" />
						</div>
					</div>
					<div className="form-group row">
						<label htmlFor="parentCategory" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Parent Category</label>
						<div className="col-lg-5">
							<Select
								value={parentCategory}
								onChange={handleParentCategoryChange}
								options={parentCategories}
								menuPosition="fixed"
								isClearable
								placeholder="Select Parent Category"
								isDisabled={!productCategory.idProjects}
							/>
						</div>
					</div>
				</Modal.Body>
				<Modal.Footer>

					<button type="submit" disabled={isSubmitDisable || loading} className="btn btn-sm btn-primary me-2">
						{loading &&
							<Spinner
								as="span"
								animation="grow"
								size="sm"
								role="status"
								aria-hidden="true"
							/>
						}
						<span>  Submit</span>
					</button>
					<Button variant='secondary' size="sm" onClick={() => handleClose(false)}>
						Close
					</Button>
				</Modal.Footer>
			</form>
		</Modal>
	)
}

export default ProductCategoryCreate
